import { Component, Input } from '@angular/core';
import { ToastController, AlertController, NavController } from '@ionic/angular';
import { PouchService } from '../../services/pouch-service';
import * as moment from 'moment';
import { Router, NavigationEnd } from '@angular/router';
import { PreviousRouteService } from '../../services/previous-route-service';
declare let firebase: any;

@Component({
  selector: 'header-buttons',
  templateUrl: './header-buttons.html',
  styleUrls: ['header-buttons.scss'],
})
export class HeaderButtonsComponent {
  @Input() page = '';
  attendance: any;
  showattendance = false;
  update = {
    version: '1.0.0',
    url: '',
  };
  root = false;

  constructor(public db: PouchService, private router: Router, private previousRouteService: PreviousRouteService, public navCtrl: NavController, public toastController: ToastController, public alertCtrl: AlertController) {
    let prev = this.previousRouteService.getPreviousUrl();
    if (prev != undefined && prev != '/LoginUserPage') {
      this.root = false;
    } else {
      this.root = true;
    }
  }

  async logout() {
    const alert = await this.alertCtrl.create({
      header: 'Logout',
      message: 'Are you sure you want to logout?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {},
        },
        {
          text: 'Yes',
          handler: () => {
            let database = localStorage.getItem('customer_database');
            localStorage.removeItem('customer_database');
            localStorage.removeItem('customer_database_name');
            localStorage.removeItem('customer_setting');
            localStorage.removeItem('customer_customer');
            localStorage.removeItem('customer_url');
            this.router.navigateByUrl(`/${database.split('$')[1]}`);
          },
        },
      ],
    });
    alert.present();
  }

  open(page) {
    this.router.navigateByUrl(page);
  }

  help() {
    window.open('https://sarutech.com/documentation/' + this.page);
  }

  viewEntity(mode): void {
    this.router.navigateByUrl('/EntitysPage', { state: { mode: mode } });
  }
  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }
}
